export const users = [
  {
    id: 1,
    password: "123456",
    firstName: "Ahmed",
    lastName: "Al Maktoum",
    contactInfo: ["ahmed.almaktoum@email.com", "0501234567"],
    address: "Dubai, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "2 years",
    technicalKnowledge: ["JavaScript", "HTML", "CSS"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
    requst_access:true
  },
  {
    id: 2,
    password: "123456",
    firstName: "Fatima",
    lastName: "Al Qassimi",
    contactInfo: ["fatima.alqassimi@email.com", "0552345678"],
    address: "Abu Dhabi, UAE",
    educationLevel: "Master's Degree",
    workExperience: "5 years",
    technicalKnowledge: ["React.js", "Node.js", "MongoDB"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["admin"],
  },
  {
    id: 3,
    password: "123456",
    firstName: "Saeed",
    lastName: "Al Muhairi",
    contactInfo: ["saeed.almuhairi@email.com", "0503456789"],
    address: "Sharjah, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "3 years",
    technicalKnowledge: ["Python", "Django", "PostgreSQL"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["admin"],
  },
  {
    id: 4,
    password: "123456",
    firstName: "Aisha",
    lastName: "Al Mansoori",
    contactInfo: ["aisha.almansoori@email.com", "0554567890"],
    address: "Dubai, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "2 years",
    technicalKnowledge: ["JavaScript", "React.js", "Firebase"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },
  {
    id: 5,
    password: "123456",
    firstName: "Khalid",
    lastName: "Al Falasi",
    contactInfo: ["khalid.alfalasi@email.com", "0505678901"],
    address: "Abu Dhabi, UAE",
    educationLevel: "Master's Degree",
    workExperience: "6 years",
    technicalKnowledge: ["Node.js", "Express.js", "MongoDB"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["admin"],
  },

  {
    id: 6,
    password: "123456",
    firstName: "Amira",
    lastName: "Abdullah",
    contactInfo: ["amira.abdullah@example.com", "+971 50 123 4567"],
    address: "123 Main St, Dubai",
    educationLevel: "Bachelor's Degree",
    workExperience: "2 years",
    technicalKnowledge: ["JavaScript", "HTML", "CSS"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },
  {
    id: 7,
    password: "123456",
    firstName: "Sara",
    lastName: "Ahmed",
    contactInfo: ["sara.ahmed@example.com", "+971 52 234 5678"],
    address: "456 Oak Ave, Abu Dhabi",
    educationLevel: "Master's Degree",
    workExperience: "5 years",
    technicalKnowledge: ["React.js", "Node.js", "MongoDB"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["admin"],
  },
  {
    id: 8,
    password: "123456",
    firstName: "Ali",
    lastName: "Al Maktoum",
    contactInfo: ["ali.almaktoum@example.com", "+971 55 345 6789"],
    address: "789 Al Falah St, Abu Dhabi",
    educationLevel: "Bachelor's Degree",
    workExperience: "3 years",
    technicalKnowledge: ["Java", "Spring Boot", "MySQL"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },
  {
    id: 9,
    password: "123456",
    firstName: "Hassan",
    lastName: "Al Mansoori",
    contactInfo: ["hassan.almansoori@example.com", "+971 50 567 8901"],
    address: "456 Al Mina Rd, Dubai",
    educationLevel: "Bachelor's Degree",
    workExperience: "4 years",
    technicalKnowledge: ["JavaScript", "React.js", "Node.js"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },

  {
    id: 10,
    password: "123456",
    firstName: "Mohammed",
    lastName: "Ahmed",
    contactInfo: ["mohammed.ahmed@email.com", "0501234567"],
    address: "Dubai, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "2 years",
    technicalKnowledge: ["JavaScript", "HTML", "CSS"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },
  {
    id: 11,
    password: "123456",
    firstName: "Fatima",
    lastName: "Ali bint saeed",
    contactInfo: ["fatima.ali@email.com", "0552345678"],
    address: "Abu Dhabi, UAE",
    educationLevel: "Master's Degree",
    workExperience: "5 years",
    technicalKnowledge: ["React.js", "Node.js", "MongoDB"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user", "admin"],
  },
  {
    id: 12,
    password: "123456",
    firstName: "Saif",
    lastName: "al mansoori",
    contactInfo: ["saif.almansoori@email.com", "0523456789"],
    address: "Sharjah, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "3 years",
    technicalKnowledge: ["Java", "Spring Framework", "MySQL"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },
  {
    id: 13,
    password: "123456",
    firstName: "Aisha",
    lastName: "Khalid",
    contactInfo: ["aisha.khalid@email.com", "0509876543"],
    address: "Dubai, UAE",
    educationLevel: "Master's Degree",
    workExperience: "7 years",
    technicalKnowledge: ["Angular", "TypeScript", "Firebase"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user", "admin"],
  },
  {
    id: 14,
    password: "123456",
    firstName: "Ali",
    lastName: "Hussein",
    contactInfo: ["ali.hussein@email.com", "0548765432"],
    address: "Abu Dhabi, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "4 years",
    technicalKnowledge: ["Python", "Django", "PostgreSQL"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user"],
  },
  {
    id: 15,
    password: "123456",
    firstName: "Fakhre",
    lastName: "Alam",
    contactInfo: ["alamnaryab@gmail.com", "0548765432"],
    address: "Abu Dhabi, UAE",
    educationLevel: "Master's Degree",
    workExperience: "11 years",
    technicalKnowledge: ["C#", "PHP", "databases", "Frontend"],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user", "super_admin"],
  },
  {
    id: 16,
    password: "123456",
    firstName: "Afra",
    lastName: "Afra",
    contactInfo: ["afra@email.com", "0548765432"],
    address: "Abu Dhabi, UAE",
    educationLevel: "Bachelor's Degree",
    workExperience: "5 years",
    technicalKnowledge: [
      "Talent acquisition",
      "Staffing and Recruitment",
      "HR & Payroll",
    ],
    cvAttachment: "https://example.com/cv.pdf",
    role: ["user", "super_admin"],
  },
];
